<template>
  <div>
    <h1><router-link :to="{ name: 'admin-design-survey' }">Design</router-link> - Add Field</h1>
    <tabs cache-lifetime="0" @changed="handleTabChange($event)">
      <tab name="Basic Info">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'basicInfo', 'new')"
          :model="formModel"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>
      </tab>
      <tab name="Validation">
        <vue-form-generator
          :schema="buildSchema('field', 'fieldSchema', 'validation', 'new')"
          :model="formModel"
          :options="formOptions"
          class="vue-form-generator--admin">
        </vue-form-generator>
      </tab>
    </tabs>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import newForm from '@/mixins/new-form';

  export default {
    name: 'admin-new-field',
    mixins: [newForm],

    data() {
      return {
        formName: 'Field',
        formParent: 'Page',
        formIndex: 'admin-design-survey',
      };
    },

    computed: {
      ...mapGetters('admin', [
        'activePage',
      ]),
    },
  };
</script>
